import BaseController from '../baseSystemController';
import eFeedbackFormControllerTypes from './eFormControllerTypes';
import FileDrop from '../../common/fileDrop';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../../utils/constants';
import { eInputTypes } from '../../../../enums/inputTypes';
import UserAgentDetector from '../../../../utils/UserAgentDetector';
import ControllerSpinner from '../../common/ControllerSpinner';

export default class ControllerFeedbackForm extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });

    this._rating = {
      selected: null,
      hovered: null,
    };

    this._ratingInputElements = [];
    this._eButtonsTypes = {
      EBT_RATING_0: 'rating_0',
      EBT_RATING_1: 'rating_1',
      EBT_RATING_2: 'rating_2',
      EBT_RATING_3: 'rating_3',
      EBT_RATING_4: 'rating_4',
    };

    this._eInputTypes = {
      EIT_TEXTAREA_RULES_FEEDBACK: 'textarea_rules_feedback',
      EIT_TEXTAREA_ANTICIPATED_FEATURE: 'textarea_anticipated_feature',
      EIT_TEXTAREA_VISUAL_IMPRESSIONS: 'textarea_visual_impressions',
      EIT_TEXTAREA_PROPOSALS: 'textarea_proposals',
      EIT_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS: 'input_compatibility_of_mechanics_and_visuals',
      EIT_TEXTAREA_POSITIVES: 'textarea_positives',
      EIT_TEXTAREA_NEGATIVES: 'textarea_negatives',
      EIT_TEXTAREA_COMMENT: 'textarea_comment',
      EIT_TEXTAREA_SOUND_LIKED: 'textarea_sound_liked',
      EIT_TEXTAREA_PLAYED_WITH_SOUND: 'textarea_played_with_sound',
      EIT_TEXTAREA_WOULD_COME_BACK: 'textarea_would_come_back',
      EIT_TEXTAREA_WHY_NOT_COME_BACK: 'textarea_why_not_come_back',
      EIT_TEXTAREA_CRITICS: 'textarea_critics',
      EIT_INPUT_TWITTER_NICKNAME: 'input_twitter_nickname',
      EIT_INPUT_DISCORD_NICKNAME: 'input_discord_nickname',
    };

    this._eButtonsActions = Object.values(this._eButtonsTypes).reduce((acc, type, index) => {
      acc[type] = (e) => {
        this._rating.selected = index;
        this._updateRating(index);
      }
      return acc;
    }, {});

    this._eEventTypes = {
      SUBMIT: `${this.controllerType}__submit`,
    }

    this._eControllersClasses = {
      [this.controllerTypes.EFFCT_FILE_DROP]: FileDrop,
      [this.controllerTypes.EFFCT_SPINNER]: ControllerSpinner,
    }

    this._eElementsTypes = {
      EET_FORM: 'form',
      EET_DESCRIPTION: 'description',
      EET_TEXTAREA_RULES_FEEDBACK_LABEL: `${this._eInputTypes.EIT_TEXTAREA_RULES_FEEDBACK}_label`,
      EET_TEXTAREA_RULES_FEEDBACK: this._eInputTypes.EIT_TEXTAREA_RULES_FEEDBACK,
      EET_TEXTAREA_ANTICIPATED_FEATURE_LABEL: `${this._eInputTypes.EIT_TEXTAREA_ANTICIPATED_FEATURE}_label`,
      EET_TEXTAREA_ANTICIPATED_FEATURE: this._eInputTypes.EIT_TEXTAREA_ANTICIPATED_FEATURE,
      EET_TEXTAREA_VISUAL_IMPRESSIONS_LABEL: `${this._eInputTypes.EIT_TEXTAREA_VISUAL_IMPRESSIONS}_label`,
      EET_TEXTAREA_VISUAL_IMPRESSIONS: this._eInputTypes.EIT_TEXTAREA_VISUAL_IMPRESSIONS,
      EET_TEXTAREA_PROPOSALS_LABEL: `${this._eInputTypes.EIT_TEXTAREA_PROPOSALS}_label`,
      EET_TEXTAREA_PROPOSALS: this._eInputTypes.EIT_TEXTAREA_PROPOSALS,
      EET_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS_LABEL: `${this._eInputTypes.EIT_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS}_label`,
      EET_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS: this._eInputTypes.EIT_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS,
      EET_TEXTAREA_POSITIVES_LABEL: `${this._eInputTypes.EIT_TEXTAREA_POSITIVES}_label`,
      EET_TEXTAREA_POSITIVES: this._eInputTypes.EIT_TEXTAREA_POSITIVES,
      EET_TEXTAREA_NEGATIVES_LABEL: `${this._eInputTypes.EIT_TEXTAREA_NEGATIVES}_label`,
      EET_TEXTAREA_NEGATIVES: this._eInputTypes.EIT_TEXTAREA_NEGATIVES,
      EET_TEXTAREA_COMMENT_LABEL: `${this._eInputTypes.EIT_TEXTAREA_COMMENT}_label`,
      EET_TEXTAREA_COMMENT: this._eInputTypes.EIT_TEXTAREA_COMMENT,
      EET_TEXTAREA_SOUND_LIKED_LABEL: `${this._eInputTypes.EIT_TEXTAREA_SOUND_LIKED}_label`,
      EET_TEXTAREA_SOUND_LIKED: this._eInputTypes.EIT_TEXTAREA_SOUND_LIKED,
      EET_TEXTAREA_PLAYED_WITH_SOUND_LABEL: `${this._eInputTypes.EIT_TEXTAREA_PLAYED_WITH_SOUND}_label`,
      EET_TEXTAREA_PLAYED_WITH_SOUND: this._eInputTypes.EIT_TEXTAREA_PLAYED_WITH_SOUND,
      EET_TEXTAREA_WOULD_COME_BACK_LABEL: `${this._eInputTypes.EIT_TEXTAREA_WOULD_COME_BACK}_label`,
      EET_TEXTAREA_WOULD_COME_BACK: this._eInputTypes.EIT_TEXTAREA_WOULD_COME_BACK,
      EET_TEXTAREA_WHY_NOT_COME_BACK_LABEL: `${this._eInputTypes.EIT_TEXTAREA_WHY_NOT_COME_BACK}_label`,
      EET_TEXTAREA_WHY_NOT_COME_BACK: this._eInputTypes.EIT_TEXTAREA_WHY_NOT_COME_BACK,
      EET_TEXTAREA_CRITICS_LABEL: `${this._eInputTypes.EIT_TEXTAREA_CRITICS}_label`,
      EET_TEXTAREA_CRITICS: this._eInputTypes.EIT_TEXTAREA_CRITICS,
      EET_INPUT_TWITTER_NICKNAME_LABEL: `${this._eInputTypes.EIT_INPUT_TWITTER_NICKNAME}_label`,
      EET_INPUT_TWITTER_NICKNAME: this._eInputTypes.EIT_INPUT_TWITTER_NICKNAME,
      EET_INPUT_DISCORD_NICKNAME_LABEL: `${this._eInputTypes.EIT_INPUT_DISCORD_NICKNAME}_label`,
      EET_INPUT_DISCORD_NICKNAME: this._eInputTypes.EIT_INPUT_DISCORD_NICKNAME,
      EET_CONTAINER_FILE_DROP_LABEL: `${this.controllerTypes.EFFCT_FILE_DROP}_label`,
      EET_CONTAINER_FILE_DROP: this.controllerTypes.EFFCT_FILE_DROP,
      EET_CONTAINER_SPINNER: this.controllerTypes.EFFCT_SPINNER,
      EET_RATING_0: this._eButtonsTypes.EBT_RATING_0,
      EET_RATING_1: this._eButtonsTypes.EBT_RATING_1,
      EET_RATING_2: this._eButtonsTypes.EBT_RATING_2,
      EET_RATING_3: this._eButtonsTypes.EBT_RATING_3,
      EET_RATING_4: this._eButtonsTypes.EBT_RATING_4,
      EET_BUTTON_SUBMIT: 'submit'
    }

    this._localizations = {
      [this._eElementsTypes.EET_DESCRIPTION]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.description`,
      [this._eElementsTypes.EET_TEXTAREA_RULES_FEEDBACK_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.rules`,
      [this._eElementsTypes.EET_TEXTAREA_ANTICIPATED_FEATURE_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.anticipated_feature`,
      [this._eElementsTypes.EET_TEXTAREA_VISUAL_IMPRESSIONS_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.visual_impressions`,
      [this._eElementsTypes.EET_TEXTAREA_PROPOSALS_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.proposals`,
      [this._eElementsTypes.EET_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.compatibility_of_mechanics_and_visuals`,
      [this._eElementsTypes.EET_TEXTAREA_POSITIVES_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.positives`,
      [this._eElementsTypes.EET_TEXTAREA_NEGATIVES_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.negatives`,
      [this._eElementsTypes.EET_TEXTAREA_COMMENT_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.comment`,
      [this._eElementsTypes.EET_TEXTAREA_SOUND_LIKED_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.sound_liked`,
      [this._eElementsTypes.EET_TEXTAREA_PLAYED_WITH_SOUND_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.played_with_sound`,
      [this._eElementsTypes.EET_TEXTAREA_WOULD_COME_BACK_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.would_come_back`,
      [this._eElementsTypes.EET_TEXTAREA_WHY_NOT_COME_BACK_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.why_not_come_back`,
      [this._eElementsTypes.EET_TEXTAREA_CRITICS_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.critics`,
      [this._eElementsTypes.EET_INPUT_TWITTER_NICKNAME_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.twitter_nickname`,
      [this._eElementsTypes.EET_INPUT_DISCORD_NICKNAME_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.discord_nickname`,
      [this._eElementsTypes.EET_CONTAINER_FILE_DROP_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.labels.file`,
      [this._eElementsTypes.EET_BUTTON_SUBMIT]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.submit`
    }
    this._placeholderLocalizationKey = `${OP_WRAPPER_LOCALIZATION_PREFIX}.feedback.placeholder`;

    this.init(container);
  }

  onShow() {
    super.onShow();
    const { remove, execute } = window.OPWrapperService.SystemUI.showGoogleCaptcha();
    this._removeCaptcha = remove;
    this._executeCaptcha = execute;
  }

  _afterInit() {
    super._afterInit();
    this._ratingInputElements = Object.values(this._eButtonsTypes).map(type => this.interactiveElements[type]);

    if (!UserAgentDetector.isMobile.any) {
      this._ratingInputElements.forEach((input, _, arr) => {
        const label = input.parentElement;

        label.onpointerenter = () => {
          this._rating.hovered = Number(input.dataset.index);
          this._updateRating(this._rating.hovered);
        }
        label.onpointerleave = () => {
          this._rating.hovered = null;
          this._updateRating(this._rating.selected === null ? -1 : this._rating.selected);
        }
      });
    }

    const numberInput = this.interactiveElements[this._eElementsTypes.EET_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS];
    numberInput.addEventListener('input', (e) => {
      const value = Number(e.target.value);
      if (value < 1 || value > 10 || isNaN(value)) {
        numberInput.setCustomValidity('Please enter a number between 1 and 10')
      } else {
        numberInput.setCustomValidity('');
      }
    })

    const form = this.interactiveElements[this._eElementsTypes.EET_FORM];
    form.onsubmit = (e) => {
      e.preventDefault();
      this.loading = true;

      const formData = new FormData(e.target);
      const data = {};
      for (let entry of formData) {
        data[entry[0]] = entry[1];
      }
      // override file. If file was drag n dropped it wouldn't be inside input;
      data.file = this.controllers[this.controllerTypes.EFFCT_FILE_DROP].file;

      this._executeCaptcha((captcha) => {
        this.emit(this._eEventTypes.SUBMIT, { ...data, captcha });
      }, 'feedback_form');
    }
  }

  cleanup() {
    super.cleanup();
    Object.values(this._eInputTypes).forEach(type => {
      this.interactiveElements[type].value = '';
    })
    this._rating.hovered = null;
    this._rating.selected = null;
    this._updateRating(-1);
    this.interactiveElements[this._eElementsTypes.EET_FORM].reset();
    this.loading = false;
    this._removeCaptcha && this._removeCaptcha();
  }

  _updateLocalizations() {
    super._updateLocalizations();
    Object.values(this._eInputTypes).forEach(type => {
      if (/input/.test(type)) return;
      this.interactiveElements[type].setAttribute('placeholder', this._getLocalization(this._placeholderLocalizationKey));
    })
  }

  _updateRating(index) {
    this._ratingInputElements.forEach((input, i) => {
      if (i <= index) {
        input.parentElement.classList.add('system-ui-container__modal__feedback__form__inputs__rating_active');
      } else {
        input.parentElement.classList.remove('system-ui-container__modal__feedback__form__inputs__rating_active');
      }
    })
  }

  set loading(value) {
    if (value) {
      this.controllers[this.controllerTypes.EFFCT_SPINNER].show();
      this.block(this._eElementsTypes.EET_BUTTON_SUBMIT);
    } else {
      this.controllers[this.controllerTypes.EFFCT_SPINNER].hide();
      this.unblock(this._eElementsTypes.EET_BUTTON_SUBMIT);
    }
  }

  get controllerTypes() {
    return eFeedbackFormControllerTypes;
  }

  _getMarkup() {
    return `<form id=${this.interactiveElementsIds[this._eElementsTypes.EET_FORM]} class="system-ui-container__modal__feedback__form">
              <div class="system-ui-container__modal__feedback__form__container_spinner" id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_SPINNER]}></div>

              <div class="system-ui-container__modal__feedback__form__head">
                <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_DESCRIPTION]} class="system-ui-container__modal__feedback__form__head__description">
                  ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DESCRIPTION])}
                </span>
              </div>
              
              <div class="system-ui-container__modal__feedback__form__inputs">
              
                <div class="system-ui-container__modal__feedback__form__inputs__rating">
                  ${Array.from({ length: 5 }, (_, index) =>
                    `<label class="system-ui-container__modal__feedback__form__inputs__rating">
                      <input name="rating" type="radio" value=${index + 1} id=${this.interactiveElementsIds[this._eElementsTypes[`EET_RATING_${index}`]]}
                        data-index=${index} required />
                    </label>`
                  ).join('')}
                </div>
                
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_RULES_FEEDBACK_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_RULES_FEEDBACK_LABEL])}
                  </span>
                  <textarea name="rules_feedback" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_RULES_FEEDBACK]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_ANTICIPATED_FEATURE_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_ANTICIPATED_FEATURE_LABEL])}
                  </span>
                  <textarea name="anticipated_feature" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_ANTICIPATED_FEATURE]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_VISUAL_IMPRESSIONS_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_VISUAL_IMPRESSIONS_LABEL])}
                  </span>
                  <textarea name="visual_impressions" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_VISUAL_IMPRESSIONS]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS_LABEL])}
                  </span>
                  <input name="compatibility_of_mechanics_and_visuals" id=${this.interactiveElementsIds[this._eElementsTypes.EET_INPUT_COMPATIBILITY_OF_MECHANICS_AND_VISUALS]} type="number" min="1" max="10" placeholder="1 - 10"/>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_SOUND_LIKED_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_SOUND_LIKED_LABEL])}
                  </span>
                  <textarea name="sound_liked" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_SOUND_LIKED]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_PLAYED_WITH_SOUND_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_PLAYED_WITH_SOUND_LABEL])}
                  </span>
                  <textarea name="played_with_sound" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_PLAYED_WITH_SOUND]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_PROPOSALS_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_PROPOSALS_LABEL])}
                  </span>
                  <textarea name="proposals" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_PROPOSALS]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_WOULD_COME_BACK_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_WOULD_COME_BACK_LABEL])}
                  </span>
                  <textarea name="would_come_back" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_WOULD_COME_BACK]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_WHY_NOT_COME_BACK_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_WHY_NOT_COME_BACK_LABEL])}
                  </span>
                  <textarea name="why_not_come_back" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_WHY_NOT_COME_BACK]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_CRITICS_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_CRITICS_LABEL])}
                  </span>
                  <textarea name="critics" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_CRITICS]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                
                <div class="system-ui-container__modal__feedback__form__inputs__split_container">
                  <label>
                    <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_POSITIVES_LABEL]}>
                      ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_POSITIVES_LABEL])}
                    </span>
                    <textarea name="positives" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_POSITIVES]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                  </label>
                  <label>
                    <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_NEGATIVES_LABEL]}>
                      ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_NEGATIVES_LABEL])}
                    </span>
                    <textarea name="negatives" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_NEGATIVES]} maxlength="5000" required placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                  </label>
                </div>
                
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_COMMENT_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TEXTAREA_COMMENT_LABEL])}
                  </span>
                  <textarea name="comment" id=${this.interactiveElementsIds[this._eElementsTypes.EET_TEXTAREA_COMMENT]} maxlength="10000" placeholder=${this._getLocalization(this._placeholderLocalizationKey)}></textarea>
                </label>
                
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_INPUT_TWITTER_NICKNAME_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_INPUT_TWITTER_NICKNAME_LABEL])}
                  </span>
                  <input name="twitter_nickname" id=${this.interactiveElementsIds[this._eElementsTypes.EET_INPUT_TWITTER_NICKNAME]} maxlength="100" required ></input>
                </label>
                
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_INPUT_DISCORD_NICKNAME_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_INPUT_DISCORD_NICKNAME_LABEL])}
                  </span>
                  <input name="discord_nickname" id=${this.interactiveElementsIds[this._eElementsTypes.EET_INPUT_DISCORD_NICKNAME]} maxlength="100" required ></input>
                </label>
                
                <label>
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_FILE_DROP_LABEL]}>
                    ${this._getLocalization(this._localizations[this._eElementsTypes.EET_CONTAINER_FILE_DROP_LABEL])}
                  </span>
                  <div class="system-ui-container__modal__feedback__form__inputs__file" id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_FILE_DROP]}></div>
                </label>
              </div>
              
              <button type="submit" class="system-ui-container__modal__feedback__form__submit" id=${this.interactiveElementsIds[this._eElementsTypes.EET_BUTTON_SUBMIT]}>
                ${this._getLocalization(this._localizations[this._eElementsTypes.EET_BUTTON_SUBMIT])}
              </button>
            </form>`
  }
}
